export var GET_ALL_MANAGERS = '[Managers] Get All';
export var GET_MANAGER = '[Managers] Get Manager';
export var GET_ALL_MANAGERS_SUCCESS = '[Managers] Get All Success';
export var GET_ALL_MANAGERS_ERROR = '[Managers] Get All Error';
export var GET_MANAGER_SUCCESS = '[Managers] Get Manager Success';
export var GET_MANAGER_ERROR = '[Managers] Get Manager Error';
export var ADD_MANAGER = '[Manager] Add';
export var ADD_MANAGER_SUCCESS = '[Manager] Add Success';
export var ADD_MANAGER_ERROR = '[Manager] Add Error';
export var UPDATE_MANAGER = '[Manager] Update';
export var UPDATE_MANAGER_SUCCESS = '[Manager] Update Success';
export var UPDATE_MANAGER_ERROR = '[Manager] Update Error';
var GetAllManagers = /** @class */ (function () {
    function GetAllManagers() {
        this.type = GET_ALL_MANAGERS;
    }
    return GetAllManagers;
}());
export { GetAllManagers };
var GetAllManagersSuccess = /** @class */ (function () {
    function GetAllManagersSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_MANAGERS_SUCCESS;
    }
    return GetAllManagersSuccess;
}());
export { GetAllManagersSuccess };
var GetAllManagersError = /** @class */ (function () {
    function GetAllManagersError(payload) {
        this.payload = payload;
        this.type = GET_ALL_MANAGERS_ERROR;
    }
    return GetAllManagersError;
}());
export { GetAllManagersError };
var GetManager = /** @class */ (function () {
    function GetManager(payload) {
        this.payload = payload;
        this.type = GET_MANAGER;
    }
    return GetManager;
}());
export { GetManager };
var GetManagerSuccess = /** @class */ (function () {
    function GetManagerSuccess(payload) {
        this.payload = payload;
        this.type = GET_MANAGER_SUCCESS;
    }
    return GetManagerSuccess;
}());
export { GetManagerSuccess };
var GetManagerError = /** @class */ (function () {
    function GetManagerError(payload) {
        this.payload = payload;
        this.type = GET_MANAGER_ERROR;
    }
    return GetManagerError;
}());
export { GetManagerError };
var AddManager = /** @class */ (function () {
    function AddManager(payload) {
        this.payload = payload;
        this.type = ADD_MANAGER;
    }
    return AddManager;
}());
export { AddManager };
var AddManagerSuccess = /** @class */ (function () {
    function AddManagerSuccess(payload) {
        this.payload = payload;
        this.type = ADD_MANAGER_SUCCESS;
    }
    return AddManagerSuccess;
}());
export { AddManagerSuccess };
var AddManagerError = /** @class */ (function () {
    function AddManagerError(payload) {
        this.payload = payload;
        this.type = ADD_MANAGER_ERROR;
    }
    return AddManagerError;
}());
export { AddManagerError };
var UpdateManager = /** @class */ (function () {
    function UpdateManager(payload) {
        this.payload = payload;
        this.type = UPDATE_MANAGER;
    }
    return UpdateManager;
}());
export { UpdateManager };
var UpdateManagerSuccess = /** @class */ (function () {
    function UpdateManagerSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_MANAGER_SUCCESS;
    }
    return UpdateManagerSuccess;
}());
export { UpdateManagerSuccess };
var UpdateManagerError = /** @class */ (function () {
    function UpdateManagerError(payload) {
        this.payload = payload;
        this.type = UPDATE_MANAGER_ERROR;
    }
    return UpdateManagerError;
}());
export { UpdateManagerError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/actions/manager.action.ts.pre-build-optimizer.js